export default {

  // 管理者としてログインしているかどうか
  isAdminUserLogin: (state) => (state.auth.ircd != '') &&
                    (state.auth.token != '') &&
    (state.adminLoginUserInfo.irnm != ''),

  // 管理者ユーザー名の取得
  getAdminUserName: (state) => (state.adminLoginUserInfo.irnm == '')
    ? '' : state.adminLoginUserInfo.irnm,

  // 一般ユーザーとしてログインしているかどうか
  isCommonUserLogin: (state) => (state.auth.ircd != '')
      && (state.auth.trsq != '')
      && (state.auth.token != '')
      && (state.commonUserInfo.irnm != '')
    && (state.commonUserInfo.name != ''),

  // 医療機関コードを持っているかどうか
  isIrcd: (state) => (state.auth.ircd != ''),

  // 一般ユーザー受診医療機関の取得
  getCommonIrnm: (state) => (state.commonUserInfo.irnm == '')
      ? '' : state.commonUserInfo.irnm,

  // 一般ユーザー受診医療機関URLパラメーターの取得
  getCommonParam: (state) => (state.commonUserInfo.pram == '')
      ? '' : state.commonUserInfo.pram,

  // 一般ユーザー名の取得 
  getCommonUserName: (state) => (state.commonUserInfo.name == '')
      ? '' : state.commonUserInfo.name,
}



// WEBPACK FOOTER //
// ./src/store/getters.js